<mb-card-base
  class="ratio-card"
  [class.content-bottom]="alignContent === 'bottom'"
  [class.content-top]="alignContent === 'top'"
  [sperateFooter]="sperateFooter"
>
  <ng-container media>
    <ng-content select="[media]"></ng-content>
    @if (data.isArchived) {
      <!-- class lives on a wrapper: Angular hydration re-applies static classes on SSR'd wb-* hosts and wipes Stencil's `hydrated` -->
      <div class="archived-tag">
        <wb-tag variant="tertiary" theme="light">{{ 'ARCHIVED_CONTENT' | translate }}</wb-tag>
      </div>
    }
  </ng-container>

  @if (data.icon) {
    <span class="mb-icon {{ data.icon }}" icon></span>
  }
  @if (data.topline) {
    <div class="topline copy-s" topline [innerHTML]="data.topline"></div>
  }
  @if (data.headline) {
    <h2 class="headline h3" headline [innerHTML]="data.headline"></h2>
  }
  @if (data.text) {
    <div class="text copy-m" text [innerHTML]="data.text"></div>
  }
  @if (fuelLabelPosition === 'default' && data.fuelLabel) {
    <div class="fuel-label copy-s font-family-text" fuel-label [innerHTML]="data.fuelLabel"></div>
  }

  @if (data.translatableMetaItems?.length) {
    <ng-container meta-items>
      <ul class="meta-items">
        @for (item of data.translatableMetaItems; track item.key) {
          <li class="meta-item">{{ item.key | translate: item.data }}</li>
        }
      </ul>
    </ng-container>
  }
  @if (data.metaItems?.length) {
    <ng-container meta-items>
      <ul class="meta-items">
        @for (item of data.metaItems; track item) {
          <li class="meta-item">{{ item }}</li>
        }
      </ul>
    </ng-container>
  }

  @if (data.tags?.length) {
    <ng-container tags>
      <ul class="tag-items">
        @for (item of data.tags; track item) {
          <li class="tag-item mb-badge-small">{{ item }}</li>
        }
      </ul>
    </ng-container>
  }

  <ng-content action-container select="[action-container]"></ng-content>
</mb-card-base>

@if (fuelLabelPosition === 'bottom' && data.fuelLabel) {
  <div class="fuel-label fuel-label-bottom copy-s font-family-text" [innerHTML]="data.fuelLabel"></div>
}
